import { render } from "./ButtonList.vue?vue&type=template&id=d5d80d90&scoped=true&ts=true"
import script from "./ButtonList.vue?vue&type=script&lang=ts"
export * from "./ButtonList.vue?vue&type=script&lang=ts"

import "./ButtonList.vue?vue&type=style&index=0&id=d5d80d90&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d80d90"]])

export default __exports__